export default {
  placeholder: 'Začněte psát zde…',
  Link: {
    title: 'Nastavte odkaz',
    label: 'Odkaz',
    submit: 'Nastavit odkaz',
  },
};
